let logged = false;

/**
 * @returns {void}
 */
export function logConsoleCredit() {
  if (logged) return;
  logged = true;

  // eslint-disable-next-line no-console -- ブランドクレジット表示のための意図的な出力
  console.log(
    '%c🐪 Rakuda Design\n\n' +
      '🔴 https://rakudadesign.com/\n' +
      '🟢 https://open.spotify.com/show/5jM9Tl7L2cqTv69xC07rpz\n' +
      '🔵 https://dropinharajuku.com/',
    'font-size: 14px;',
  );
}
